require('./style.less');

// Using a composite view instead of Layout so can attach the collection view directly to tbody -- stopped; these will be deprecated on upgrade.
// - and should upgrade anyway, especially for increased performance
// Maybe the layout here changes anyone do to need for a fixed header, in which case we go back to Layout with collection view
// Alt: if can update to V.3 can use replaceElement option


/**
 * No theader -- print the rows views just inside the table now
 * Could get rid of this and put inside the results view now ...
 */

var Marionette = require('marionette'),
    RowHierarchyView = require('./bodyRows/rowHierarchyView');


module.exports = Marionette.LayoutView.extend({

    tagName: 'table',

    id: 'fr-results-table',

    template: require('./template.hbs'),

    initialize: function( options ) {

        this.channel = options.channel;

    },

    regions: {
        tableBodyRegion:    '#fr-results-table-body'
    },

    onBeforeShow: function() {

        // Hack: rid 'div' inserted in the region after the tbody.
        this.tableBodyRegion.once( 'show', _.bind(function() {
           this.tableBodyRegion.$el.find('tr:first').unwrap();
        }, this));


        this.tableBodyRegion.show( new RowHierarchyView({
            channel: this.channel
        }));

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/hitsTableView/view.js
 ** module id = 614
 ** module chunks = 0
 **/